import { filter } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { appConfigsApi } from 'api';
import { QueryKey, AppConfigKey, AppConfigArea, P2PProviderType } from 'enums';
import { AppConfig } from 'types';

import { useProviderTypes } from './use-provider-types.hook';

export const useP2PProvidersConfig = () => {
  const { data, isLoading } = useQuery(QueryKey.Configs, () =>
    appConfigsApi.getForAreaPaginated(AppConfigArea.P2PProvidersCommon)(),
  );
  const { providerTypeOptions } = useProviderTypes();

  const availableP2PProviderTypes = useMemo(() => {
    const defaultP2PProviderTypes = [
      P2PProviderType.InternalLike,
      P2PProviderType.TestProvider,
    ];
    return (
      data?.items?.find(
        (schema: AppConfig) =>
          schema.key === AppConfigKey.AvailableP2PProviderTypes,
      )?.jsonArrayValue || defaultP2PProviderTypes
    );
  }, [data]);

  const availableP2PProviderTypeOptions = useMemo(
    () =>
      filter(
        providerTypeOptions,
        (item) =>
          !item.isSystem || availableP2PProviderTypes.includes(item.value),
      ),
    [providerTypeOptions, availableP2PProviderTypes],
  );

  const isP2PProviderAvailable = (providerType?: P2PProviderType | string) => {
    if (!providerType) {
      return false;
    }
    if (availableP2PProviderTypes.includes(providerType)) {
      return true;
    }
    const option = providerTypeOptions.find((o) => o.value === providerType);
    return !!option && !option.isSystem;
  };

  return {
    availableP2PProviderTypes,
    availableP2PProviderTypeOptions,
    isP2PProviderAvailable,
    isLoading,
  };
};
